import { Action, configureStore, Reducer, ThunkAction } from '@reduxjs/toolkit'
import { preloadState } from '@/redux/state-persistance.ts'
import { appReducer } from '@/redux/reducers.ts'
import { extraMiddleware } from '@/redux/middleware.ts'
import { setupListeners } from '@reduxjs/toolkit/query'

const rootReducer: Reducer = (state: RootState, action) => {
  if (action.type === 'auth/logout') {
    // mutate the state
    state = {} as RootState
  }
  return appReducer(state, action)
}


export const store = configureStore({
  reducer: rootReducer,
  preloadedState: preloadState(),
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(extraMiddleware),
})
setupListeners(store.dispatch)

export type RootState = ReturnType<typeof appReducer>;

export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;